import React from 'react';
import { css } from '@emotion/core';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import BodyText from 'components/atoms/BodyText';
import { grayScale } from 'components/styles';
// import { useOrgTreesOptionsAll } from 'hooks/useOrgTreesOptions';

const OrganizationFilter: React.FC<{
  orgCode: string;
  setOrgCode: (orgCode: string) => void;
}> = ({ orgCode, setOrgCode }) =>
// const orgTreesOptions = useOrgTreesOptionsAll(undefined, undefined, false);

  (
    <FlexBox
      customStyle={css({
        paddingTop: '8px',
        paddingBottom: '8px',
      })}
    >
      <FlexBoxItem basis="100px">
        <BodyText>
          組織
        </BodyText>
      </FlexBoxItem>

      <FlexBoxItem basis="400px">
        <BodyText color={grayScale.gray100}>
          {`${sessionStorage.getItem('loginUser.orgCode') || ""} ${sessionStorage.getItem('loginUser.orgName') || ""}`}
        </BodyText>
      </FlexBoxItem>
    </FlexBox>
  );
export default OrganizationFilter;
